// SendButton Component Constants
export const SEND_BUTTON_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

export const SEND_BUTTON_DEFAULT_PROPS = {
  size: SEND_BUTTON_SIZES.MEDIUM,
  disabled: false,
  loading: false,
  className: ''
};

export const SEND_BUTTON_ICON_SIZES = {
  [SEND_BUTTON_SIZES.SMALL]: 24,
  [SEND_BUTTON_SIZES.MEDIUM]: 30,
  [SEND_BUTTON_SIZES.LARGE]: 36
};

export const SEND_BUTTON_ANIMATION_DURATION = {
  FLY_AWAY: 1500,
  TRAIL_FADE: 1500,
  HOVER: 300,
  PRESS: 100
};
